export function computePricing(p) {
  const cogs = Number(p.cogs) || 0;
  const margin = Number(p.margin) || 0;
  const overhead = Number(p.overhead) || 0;
  const volume = Number(p.volume) || 0;

  // price so that gross margin % = margin
  const price = margin < 100 ? cogs / (1 - margin / 100) : cogs * 2;
  const grossMargin = price - cogs;
  const marginPct = price > 0 ? (grossMargin / price) * 100 : 0;
  const breakEven = grossMargin > 0 ? Math.ceil(overhead / grossMargin) : 0;
  const revenue = price * volume;
  const totalCogs = cogs * volume;
  const netProfit = revenue - totalCogs - overhead;

  return {
    price: price.toFixed(2),
    grossMargin: grossMargin.toFixed(2),
    marginPct: marginPct.toFixed(1),
    breakEven,
    revenue: revenue.toFixed(0),
    netProfit: netProfit.toFixed(0),
  };
}

export function swotProgress(swot) {
  if (!swot) return 0;
  const total = ["strengths", "weaknesses", "opportunities", "threats"].reduce(
    (n, k) => n + (swot[k]?.length ? 1 : 0), 0
  );
  return Math.round((total / 4) * 100);
}
